module.exports = __webpack_public_path__ + "static/media/carousel-blue-button.d33153ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel-blue-button.svg
// module id = 872
// module chunks = 0